const homePage: Record<string, Record<string, string> | string> = {
    headerLinks: {
        campaigns: 'Конкурсы',
    },
};

export default homePage;
